import Navbar from './components/Navbar';
import Hero from './components/Hero';
import InstantImpact from './components/InstantImpact';
import Services from './components/Services';
import Sovereignty from './components/Sovereignty';
import Reassurance from './components/Reassurance';
import Process from './components/Process';
import Infographic from './components/Infographic';
import SatisfactionGuarantee from './components/SatisfactionGuarantee';
import Testimonial from './components/Testimonial';
import EcoImpact from './components/EcoImpact';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Process />
      <InstantImpact />
      <Sovereignty />
      <Reassurance />
      <Infographic />
      <SatisfactionGuarantee />
      <Testimonial />
      <EcoImpact />
      <CTA />
      <Footer />
    </div>
  );
}
